var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideStones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1885_1939",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 77,
    width: 225,
    height: 101
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237.893 77H13.8947V177.344H237.893V77Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1885_1939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.231 139.668L230.845 139.994C234.748 139.994 237.893 136.795 237.893 132.784V122.104C237.893 118.147 234.803 114.894 230.954 114.894L178.044 114.569",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5689 114.894L21.1047 114.569C17.0931 114.569 13.8405 117.767 13.8405 121.779V132.458C13.8405 136.416 17.0389 139.668 20.9962 139.668L69.7858 139.994",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.105 177.344C96.4573 177.344 73.9058 154.846 73.9058 127.145C73.9058 99.4432 96.4573 77 124.105 77C151.752 77 174.304 99.4974 174.304 127.199C174.304 154.901 151.806 177.398 124.105 177.398V177.344ZM124.105 79.6563C97.8668 79.6563 76.5621 100.961 76.5621 127.199C76.5621 153.437 97.8668 174.742 124.105 174.742C150.343 174.742 171.647 153.437 171.647 127.199C171.647 100.961 150.343 79.6563 124.105 79.6563Z",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.715 93.5332H90.4942V160.754H157.715V93.5332Z",
    stroke: "#343334",
    strokeWidth: 2.71053,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.084 79.6421L76.5518 127.175L124.084 174.707L171.617 127.175L124.084 79.6421Z",
    stroke: "#343334",
    strokeWidth: 2.71053,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4005 140.425C59.9736 140.425 54.1731 134.625 54.1731 127.198C54.1731 119.771 60.1363 113.971 67.4005 113.971C74.6647 113.971 80.6279 119.934 80.6279 127.198C80.6279 134.462 74.6647 140.425 67.4005 140.425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4005 115.326C73.96 115.326 79.2727 120.638 79.2727 127.198C79.2727 133.757 73.96 139.07 67.4005 139.07C60.841 139.07 55.5284 133.866 55.5284 127.198C55.5284 120.53 60.841 115.326 67.4005 115.326ZM67.4005 112.615C59.3231 112.615 52.8179 119.175 52.8179 127.198C52.8179 135.221 59.3773 141.78 67.4005 141.78C75.4237 141.78 81.9832 135.221 81.9832 127.198C81.9832 119.175 75.4237 112.615 67.4005 112.615Z",
    fill: "#343334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.863 140.425C173.436 140.425 167.636 134.625 167.636 127.198C167.636 119.771 173.599 113.971 180.863 113.971C188.127 113.971 194.09 119.934 194.09 127.198C194.09 134.462 188.127 140.425 180.863 140.425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.863 115.326C187.422 115.326 192.735 120.638 192.735 127.198C192.735 133.757 187.422 139.07 180.863 139.07C174.304 139.07 168.991 133.866 168.991 127.198C168.991 120.53 174.304 115.326 180.863 115.326ZM180.863 112.615C172.786 112.615 166.28 119.175 166.28 127.198C166.28 135.221 172.84 141.78 180.863 141.78C188.886 141.78 195.446 135.221 195.446 127.198C195.446 119.175 188.886 112.615 180.863 112.615Z",
    fill: "#343334"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideStones);
export default __webpack_public_path__ + "static/media/SideStones.6e1a9b35a06cd248c00c6a3bc845a7da.svg";
export { ForwardRef as ReactComponent };